// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const trustedEnrollmentIssuerSchema = z.object({
  "id": z.string().uuid(),
  "display_name": z.string(),
  "issuer": z.string(),
  "jwks_uri": z.string(),
  "audience": z.string(),
  "return_url_allowlist": z.array(z.string()),
  "enabled": z.boolean()
});

export const trustedEnrollmentIssuersResponseSchema = z.object({
  "issuers": z.array(trustedEnrollmentIssuerSchema)
});
